module.exports = __webpack_public_path__ + "static/media/pre1.3d2e5e7f.jpg";